import { toast } from "react-toastify";
import Api from "../../../axios";
import { callLoader } from "../../../common/actions/app";

let ACTION_REGION_LIST = {
    type: 'REGION_LIST',
    payload: {
        rows: [],
        total: 0,
        pagination: [],
    },
};

let ACTION_REGION_VIEW = {
    type: 'REGION_VIEW',
    payload: {
        name: '',
    },
};

let ACTION_REGION_SELECT = {
    type: 'REGION_SELECT',
    payload: [],
};

let callRegionListGet = (filter = {}, pg = 1) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/regions?pg=' + pg).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_REGION_LIST.payload.rows = data.rows
        ACTION_REGION_LIST.payload.total = data.total
        ACTION_REGION_LIST.payload.pagination = data.pagination
        dispatch(ACTION_REGION_LIST)
    })
}

let callRegionViewGet = (id) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/regions/' + id).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_REGION_VIEW.payload.name = data.name
        dispatch(ACTION_REGION_VIEW)
    })
}

let callRegionPost = (data, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.post('/regions', data).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callRegionPut = (id, data, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.put('/regions/' + id, data).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callRegionClearView = () => (dispatch) => {
    ACTION_REGION_VIEW.payload.name = ''
    dispatch(ACTION_REGION_VIEW)
}

let callRegionDelete = (id, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.delete('/regions/' + id).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callRegionSelectGet = (id) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/regions/select').then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_REGION_SELECT.payload = data
        dispatch(ACTION_REGION_SELECT)
    })
}

export { callRegionListGet, callRegionViewGet, callRegionPost, callRegionPut, callRegionClearView, callRegionDelete, callRegionSelectGet, ACTION_REGION_LIST, ACTION_REGION_VIEW, ACTION_REGION_SELECT }